// /community/ 配下のURL定義。
// src/routes/shared.tsx（コンポーネントimportを含む）から参照されるが、
// URL文字列のみを扱う軽量なモジュールとして独立させている。
const communityPath = (suffix: string): string => {
  return `/community/${suffix}`;
};

export const COMMUNITY_URL = {
  COMMUNITY_DEFAULT_CHANNEL: communityPath(''),
  COMMUNITY_CHANNEL_LIST: communityPath('channels'),
  COMMUNITY_CHANNEL: communityPath(':code'),
  COMMUNITY_CHANNEL_THREAD: communityPath(':code/:chatId/threads'),
  COMMUNITY_CHANNEL_MEMBERS: communityPath(':code/members'),
  COMMUNITY_CHANNEL_MEMBERS_INVITATION: communityPath(':code/members/invitation'),
  COMMUNITY_CHANNEL_MEMBERS_DETAIL_TENANT: communityPath(':code/members/tenant/:id'),
  COMMUNITY_CHANNEL_MEMBERS_DETAIL_COMPANY: communityPath(':code/members/company/:id'),
  COMMUNITY_CHANNEL_CHAT_SEARCH: communityPath('chat/search'),
} as const;
